export const filterDefinedFields = <T extends Record<string, any>>(obj: T, model: any): Partial<T>  => {

  if(!obj || !model) return obj;

  const modelKeys = Object.keys(model); // Get the runtime keys of the PathModel
  const result: Partial<T> = {};

  // Filter only the keys that are part of the model
  Object.keys(obj).forEach(key => {
    if (modelKeys.includes(key) && obj[key] !== undefined) {
      result[key as keyof T] = obj[key];
    }
  });

  return result;
};